(function(){
  var header=document.getElementById('siteHeader');
  var toggle=document.getElementById('menuToggle');
  var nav=document.getElementById('navOverlay');
  var isIndex=document.body.classList.contains('template-index');
  var menuOpen=false;

  /* Showcase: fix iOS viewport height */
  if(isIndex){
    var showcase=document.getElementById('showcase');
    if(showcase){
      var isIOS=/iPhone|iPad|iPod/.test(navigator.userAgent);
      if(isIOS){
        var h=window.innerHeight;
        showcase.style.height=h+'px';
        showcase.querySelectorAll('.showcase__item').forEach(function(item){item.style.height=h+'px';});
      }
    }
  }

  /* Scroll header background (non-index) */
  if(!isIndex&&header){
    window.addEventListener('scroll',function(){
      header.classList.toggle('is-scrolled',window.scrollY>50);
    },{passive:true});
  }

  /* Hamburger */
  if(toggle&&nav){
    toggle.addEventListener('click',function(){
      menuOpen=!menuOpen;
      this.classList.toggle('is-active',menuOpen);
      nav.classList.toggle('is-open',menuOpen);
      if(menuOpen){
        header.classList.remove('site-header--light');
        header.classList.add('site-header--dark');
        document.body.style.overflow='hidden';
      }else{
        if(isIndex){
          header.classList.remove('site-header--dark');
          header.classList.add('site-header--light');
        }
        document.body.style.overflow=isIndex?'hidden':'';
      }
    });
    document.querySelectorAll('.nav-overlay__main-link a, .nav-overlay__sub-link a').forEach(function(l){
      l.addEventListener('click',function(){
        menuOpen=false;
        toggle.classList.remove('is-active');
        nav.classList.remove('is-open');
        if(isIndex){
          header.classList.remove('site-header--dark');
          header.classList.add('site-header--light');
        }
        document.body.style.overflow=isIndex?'hidden':'';
      });
    });
  }

  /* Gallery progress bars */
  var gallery=document.getElementById('gallery');
  var bars=document.querySelectorAll('.product-gallery__bar, .work-gallery__bar');
  if(gallery&&bars.length){
    gallery.addEventListener('scroll',function(){
      var index=Math.round(this.scrollLeft/this.offsetWidth);
      bars.forEach(function(bar,i){bar.classList.toggle('is-active',i===index);});
    },{passive:true});
  }

  /* Accordion */
  document.querySelectorAll('.product-accordion__toggle').forEach(function(btn){
    btn.addEventListener('click',function(){
      var expanded=this.getAttribute('aria-expanded')==='true';
      this.setAttribute('aria-expanded',!expanded);
      var content=this.nextElementSibling;
      content.classList.toggle('is-open',!expanded);
    });
  });

  /* Lightbox */
  var lightbox=document.getElementById('lightbox');
  var lightboxImg=document.getElementById('lightboxImg');
  if(lightbox){
    document.querySelectorAll('.work-gallery__slide').forEach(function(slide){
      slide.addEventListener('click',function(){
        var img=this.querySelector('img');
        var fullSrc=img.getAttribute('data-full')||img.src;
        lightboxImg.src=fullSrc;
        lightboxImg.alt=img.alt;
        lightbox.classList.add('is-open');
        document.body.style.overflow='hidden';
      });
    });
    lightbox.addEventListener('click',function(){
      lightbox.classList.remove('is-open');
      document.body.style.overflow='';
    });
    var closeBtn=document.querySelector('.lightbox__close');
    if(closeBtn){
      closeBtn.addEventListener('click',function(e){
        e.stopPropagation();
        lightbox.classList.remove('is-open');
        document.body.style.overflow='';
      });
    }
  }
})();